export const myprogress = {
    uk: {
        header: "Мій прогрес",
        currentLessonButton: "Поточний урок",
        mapTitle: "Моя дорожня карта",
        mapText: "Відстежуйте свій прогрес за допомогою цієї навчальної дорожньої карти. Кожен урок містить розділи з граматики, словникового запасу, читання, аудіювання та говоріння. Уроки відкриваються поступово в міру проходження курсу (ви не зможете перейти до уроку 5, не завершивши урок 4, і так далі). ",
        cardsText: "Також уроки згруповані в блоки по шість залежно від рівня опанування матеріалу. Ви можете перейти до потрібного розділу, натиснувши відповідну кнопку нижче.",
        progressChartTitle: "Таблиця прогресу",
        progressChartText: "Таблиця прогресу заповнюється вашим викладачем у процесі проходження курсу. Студенти можуть переглядати таблицю, але вносити зміни до неї може лише викладач. Вона допомагає відстежувати ваш прогрес у граматиці, читанні, аудіюванні та говорінні для кожного уроку, щоб ви могли чітко бачити свій розвиток з часом.",
        mustLogIn: "Увійдіть, щоб переглянути свій прогрес",
        titles: [
            { title: "Уроки 1 - 6", subtitle: "Займенники і\nпрості часи" },
            { title: "Уроки 7 - 12", subtitle: "Тривалі та\nдоконані часи" },
            { title: "Уроки 13 - 18", subtitle: "Базові\nструктури" },
            { title: "Уроки 19 - 24", subtitle: "Розширена\nграматика" },
            { title: "Уроки 25 - 30", subtitle: "Повторення та закріплення" },
        ]
    },
    en: {
        header: "My Progress",
        currentLessonButton: "Current Lesson",
        mapTitle: "My Roadmap",
        mapText: "Please follow your progress using this roadmap. Each lesson includes grammar, vocabulary, reading, listening, and speaking sections. Lessons unlock as you move through the course (you can’t jump to lesson 5 until you complete lesson 4, and so on).",
        cardsText: "The lessons are also grouped in sets of six based on your mastery of the material. You can jump to the selected section by pressing the appropriate button below.",
        progressChartTitle: "Progress Chart",
        progressChartText: "The Progress Chart is filled in by your teacher as you move through the course. Students can view the chart, but only the teacher can update it. It helps your teacher track your progress in grammar, reading, listening, and speaking for each lesson, so you can clearly see how you’re developing over time.",
        mustLogIn: "You must log in to see your progress",
        titles: [
            { title: "Lessons 1 - 6", subtitle: "Pronouns & Simple Tenses" },
            { title: "Lessons 7 - 12", subtitle: "Continuous & Perfect Tenses" },
            { title: "Lessons 13 - 18", subtitle: "Core\nStructures" },
            { title: "Lessons 19 - 24", subtitle: "Advanced\nGrammar" },
            { title: "Lessons 25 - 30", subtitle: "Review & Consolidation" },
        ]
    }
}